import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=705159f8&scoped=true"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705159f8",
  null
  
)

export default component.exports